import { Skeleton } from 'primereact/skeleton'

export default function PathNormativitiesChartSkeleton() {
    return (
        <div className='path-normativities-chart-skeleton-div'>
            <Skeleton className='chart-name-skeleton'/>
            <Skeleton className='chart-content-skeleton'/>
        </div>
    )
}
